import { IconButton, Tooltip } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'react-i18next';

interface ValueLabelsToggleButtonProps {
  visible: boolean;
  onToggle: () => void;
}

export const ValueLabelsToggleButton = ({
  visible,
  onToggle,
}: ValueLabelsToggleButtonProps) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={
        visible
          ? t('ValueLabelsToggleButton.hideValuesOnBars')
          : t('ValueLabelsToggleButton.showValuesOnBars')
      }
    >
      <IconButton
        onClick={onToggle}
        sx={{
          color: visible ? 'primary.main' : 'action.disabled',
          padding: '4px',
        }}
        aria-label={t('ValueLabelsToggleButton.toggleBarValueLabels')}
      >
        {visible ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </Tooltip>
  );
};
